/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Types of invoices supported by the system
 */
export enum EnumInvoiceType {
    /**
     * A normal invoice
     */
    Invoice = 1,
    /**
     * Credit note
     */
    CreditNote = 2,
    /**
     * Cancellation to a previous invoice or credit
     */
    Cancellation = 3,
}
